export default __webpack_public_path__ + "static/media/chuck-web-idle.bfc0753d.gif";